module.exports = __webpack_public_path__ + "components/flag/static/square/sy-9cdaca661cadad59d2ece69e4f526426.svg";